import api from "./api";
class CepService {
    static async busca(cep) {
        const res = await api.get("/buscacep/" + cep);
        if (res.data.erro) {
            return undefined;
        }
        return res.data;
    }
}
export default CepService;
